import { createLogic } from 'redux-logic';
import { ALERT_TYPES, ALERT_MESSAGE } from 'config/constants';
import { createStayRating } from 'lib/stayRating';
import { displayAlert } from 'store/alert/actions';
import * as actions from '../actions';

const rateStay = createLogic({
  type: actions.rateStay,
  async process({ action }, dispatch, done) {
    const { booking, rating } = action.payload;
    const bookingId = booking.id;
    const bookingRef = booking.reference;
    const propertyId = booking.reservation.property.id;

    try {
      createStayRating({ bookingId, propertyId, rating, bookingRef });
      dispatch(displayAlert({ type: ALERT_TYPES.SUCCESS, message: ALERT_MESSAGE.STAY_RATING_SUCCESS }));
    } catch (error) {
      dispatch(displayAlert({ type: ALERT_TYPES.ERROR, message: ALERT_MESSAGE.STAY_RATING_ERROR }));
    } finally {
      done();
    }
  },
});

export default rateStay;
